import { actionCreator } from 'utils';
import * as PaymentTypeTypes from '../types/paymentTypeTypes';

// L O A D   P A Y M E N T   T Y P E
export function loadPaymentType() {
    return {
        type: PaymentTypeTypes.LOAD_PAYMENT_TYPE,
    };
}

export function loadPaymentTypeRes(data) {
    return {
        type: actionCreator(PaymentTypeTypes.LOAD_PAYMENT_TYPE, 'res'),
        data,
    };
}

export function loadPaymentTypeErr() {
    return {
        type: actionCreator(PaymentTypeTypes.LOAD_PAYMENT_TYPE, 'err'),
    };
}
// L O A D   P A Y M E N T   T Y P E

// S E T   P A Y M E N T   T Y P E   P A G I N A T I O N
export function setPaymentTypePagination(key, pagination) {
    return {
        type: PaymentTypeTypes.SET_PAYMENT_TYPE_PAGINATION,
        key,
        pagination,
    };
}
// S E T   P A Y M E N T   T Y P E   P A G I N A T I O N

// A D D   P A Y M E N T   T Y P E
export function addPaymentType(data) {
    return {
        type: PaymentTypeTypes.ADD_PAYMENT_TYPE,
        data,
    };
}

export function addPaymentTypeRes() {
    return {
        type: actionCreator(PaymentTypeTypes.ADD_PAYMENT_TYPE, 'res'),
    };
}

export function addPaymentTypeErr() {
    return {
        type: actionCreator(PaymentTypeTypes.ADD_PAYMENT_TYPE, 'err'),
    };
}
// A D D   P A Y M E N T   T Y P E

// E D I T   P A Y M E N T   T Y P E
export function editPaymentType(data) {
    return {
        type: PaymentTypeTypes.EDIT_PAYMENT_TYPE,
        data,
    };
}

export function editPaymentTypeRes() {
    return {
        type: actionCreator(PaymentTypeTypes.EDIT_PAYMENT_TYPE, 'res'),
    };
}

export function editPaymentTypeErr() {
    return {
        type: actionCreator(PaymentTypeTypes.EDIT_PAYMENT_TYPE, 'err'),
    };
}
// E D I T   P A Y M E N T   T Y P E

// L O A D   E D I T A B L E   P A Y M E N T   T Y P E
export function loadEditablePaymentType(id) {
    return {
        type: PaymentTypeTypes.LOAD_EDITABLE_PAYMENT_TYPE,
        id,
    };
}

export function loadEditablePaymentTypeRes(data) {
    return {
        type: actionCreator(PaymentTypeTypes.LOAD_EDITABLE_PAYMENT_TYPE, 'res'),
        data,
    };
}

export function loadEditablePaymentTypeErr() {
    return {
        type: actionCreator(PaymentTypeTypes.LOAD_EDITABLE_PAYMENT_TYPE, 'err'),
    };
}
// L O A D   E D I T A B L E   P A Y M E N T   T Y P E

// S E T   E D I T A B L E   P A Y M E N T   T Y P E   D A T A
export function setEditablePaymentTypeData(data) {
    return {
        type: PaymentTypeTypes.SET_EDITABLE_PAYMENT_TYPE_DATA,
        data,
    };
}
// S E T   E D I T A B L E   P A Y M E N T   T Y P E   D A T A
